import { NgModule } from '@angular/core';
import { PipeSplitIndexPipe } from './pipe-split-index';
@NgModule({
  declarations: [PipeSplitIndexPipe],
  imports: [],
  exports: [PipeSplitIndexPipe]
})
export class PipesModule {}
